export const CLIENTS = [
  { name: 'Endemol', slug: 'endemol', since: 2015 },
  { name: 'Science Abroad', slug: 'science-abroad', since: 2024 },
  { name: 'Boaz Arad Photography', slug: 'boaz-arad', since: 2017 },
  { name: 'Kenes Group', slug: 'kenes-group', since: 2019 },
  { name: 'Waves Audio', slug: 'waves-audio', since: 2025 },
  { name: 'Axel Springer / HY', slug: 'axel-springer', since: 2017 },
  { name: 'NICE', slug: 'nice', since: 2023 },
  { name: 'i24NEWS', slug: 'i24news', since: 2015 },
  { name: 'Cylus Cybersecurity', slug: 'cylus', since: 2022 },
  { name: 'SeeSaw Agency', slug: 'seesaw', since: 2018 },
];
